export default __webpack_public_path__ + "static/media/sort_down.45e314c6.svg";